import { getDashboardProperties } from "../services/partner-login-service";
import type { AdminCheckResult } from "../types/utils";

export const checkIfUserIsAdmin = async (): AdminCheckResult => {
  try {
    const res = await getDashboardProperties();
    if (res.status && res.data) {
      const userName = sessionStorage.getItem("userName");
      if (res?.data?.partnerDomainSetup === "us" && res?.data?.partnerAdminUsers && userName && res?.data?.partnerAdminUsers.indexOf(userName) > -1) {
        return true;
      }
      return false;
    }
    return false;
  } catch (error) {
    console.error(error);
    return false;
  }
};
